import React from 'react';
import * as moment from 'moment';

import ActivityMediumBox from '../Box/ActivityMediumBox';
import Buttonbar from '../Navbar/Buttonbar';
import ChipActivity from '../../../../components/Chip/ChipActivity';
import ChipCheckedActivity from '../../../../components/Chip/ChipCheckedActivity';
import StackedBarChart from '../Chart/StackedBarChart';
import NoDataBox from '../Box/NoDataBox';
import { getHoverText, dayDate, yearDate, countDays } from '../../../../utils/summaryGraph';
import * as ActionColors from '../../../../themes/summaryReportColor';
import ViewSubTypeForYearRadioBar from '../Navbar/ViewSubTypeForYearRadioBar';

const getLable = (lable, t) => {
  let result = '';
  switch (lable) {
    case 'walking':
      result = `${t('walking')}`;
      break;
    case 'standing':
      result = `${t('standing')}`;
      break;
    case 'sitting':
      result = `${t('sitting')}`;
      break;
    case 'lying':
      result = `${t('lying')}`;
      break;
    case 'total':
      result = `${t('total')}`;
      break;
    default:
      break;
  }
  return result;
};

const TotalEventLegend = (props) =>
  props.data.map((val, i) => {
    return (
      <div className='flex w-full my-auto' key={i}>
        <div className='block w-3/4'>
          <ChipActivity lable={getLable(val.label, props.t)} element={val.label} />
        </div>
        <div className='block w-3/12'>
          <div className='text-xl font-medium text-right text-summary-header '>
            {val.value.toFixed(2)}
            <span className='px-2 text-base font-normal capitalize text-summary-header '>
              %{/* {props.t("hrs")}. */}
            </span>
          </div>
        </div>
      </div>
    );
  });

const AverageEventLegend = (props) =>
  props.data.map((val, i) => {
    return (
      <div className='flex w-full my-auto' key={i}>
        <div className='block w-3/4'>
          <ChipActivity lable={getLable(val.label, props.t)} element={val.label} />
        </div>
        <div className='block w-3/12'>
          <div className='mr-2 text-xl font-medium text-right text-summary-header '>
            {val.value}
            {/* <span className="px-2 text-base font-normal capitalize text-summary-header ">
              {props.t("hrs")}
            </span> */}
          </div>
          {/* <div className="capitalize text-10 text-summary-header ">
            {`${props.t("min_value")} ${val.min} ${props.t("hrs")}. ${props.t(
              "max_value"
            )} ${val.max} ${props.t("hrs")}.`}
          </div> */}
        </div>
      </div>
    );
  });

const Event = (props) => {
  const { t } = props;
  const margin = {
    top: 20, //20,
    right: 20, //20,
    bottom: 40, //40,
    left: 60, //60
  };
  const width = 740 - margin.left - margin.right;
  const height = 515 - margin.top - margin.bottom;

  const eventColor = {
    total: ActionColors.COLOR_TOTAL,
    walking: ActionColors.COLOR_WALKING,
    standing: ActionColors.COLOR_STANDING,
    sitting: ActionColors.COLOR_SITTING,
    lying: ActionColors.COLOR_LYING,
  };

  const display = {
    total: props.display.total,
    walking: props.display.walking,
    standing: props.display.standing,
    sitting: props.display.sitting,
    lying: props.display.lying,
  };
  const lableX = props.viewType === 'year' ? t('months') : t('days_for_graph');

  const viewSubTypeForYear = props.viewSubTypeForYear;
  const viewYearTypeRadioBar =
    props.viewType === 'year' ? (
      <ViewSubTypeForYearRadioBar
        viewType={props.viewType}
        viewSubType={viewSubTypeForYear}
        t={t}
        onChangeSubViewType={(subType) => {
          props.onChangeViewSubTypeForYear('event', subType);
        }}
      />
    ) : (
      <></>
    );

  return props.hasActivity ? (
    <div className='flex-wrap flex-auto min-w-0 px-16 mb-16'>
      <div className='relative flex-col flex-wrap block col-span-12 mx-3 my-4 bg-white rounded shadow-lg'>
        <div className='block col-span-12 px-1 pt-4 lg:flex md:flex'>
          <Buttonbar onChangePeriod={props.onChangePeriod} viewType={props.viewType} t={t} />
          <div className='flex justify-end flex-auto pr-8'>{viewYearTypeRadioBar}</div>
        </div>

        <div className='px-6 pb-5'>
          <div className='flex-wrap block xl:flex'>
            <div className='w-full p-4 pt-1 xl:w-2/3'>
              <div className='flex flex-wrap flex-grow col-span-12 my-1'>
                <ChipCheckedActivity data={eventLegend(props.data, props.display)} onSelect={props.onSelect} t={t} />
              </div>
              <div className='rounded-md xl:mb-5 lg:mb-5 bg-primary-gradient h-428'>
                <StackedBarChart
                  width={width}
                  height={height}
                  margin={margin}
                  color={eventColor}
                  rect={rectProperty(props.viewType, viewSubTypeForYear)}
                  data={eventGraphData(props.date, props.data, props.viewType, viewSubTypeForYear, props.display, t)}
                  onMouseover={props.onMouseover}
                  onMouseout={props.onMouseout}
                  tooltip={props.tooltip}
                  tooltipName={getLable(props.tooltip.name, t)}
                  unit={t('hours')}
                  lableX={lableX}
                />
              </div>
            </div>

            <div className='w-full xl:w-1/3 lg:mt-16 xl:mt-0 md:-mt-8'>
              <div className='lg:flex xl:block'>
                <div className='mx-4 my-2 xl:mx-4 lg:mx-2 md:mx-4'>
                  <ActivityMediumBox header={`${t('total')} / ${t(props.viewType)}`}>
                    <div className='mt-2'>
                      <TotalEventLegend data={eventTotal(props.data, display)} t={t} />
                    </div>
                  </ActivityMediumBox>
                </div>

                <div className='mx-4 my-2 xl:mx-4 lg:mx-2 md:mx-4'>
                  <ActivityMediumBox header={`${t('avg')} / ${t('day')} (${t('hour')})`}>
                    <div className='mt-2'>
                      <AverageEventLegend data={eventAverage(props.date, props.data, props.viewType, display)} t={t} />
                    </div>
                  </ActivityMediumBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className='flex-wrap flex-auto min-w-0 px-16'>
      <NoDataBox text={t('no_data')} />
    </div>
  );
};

const rectProperty = (viewType, viewSubTypeForYear) => {
  const rectWeek = { width: 30, padding: 0.7, maxValue: 24 };
  const rectMonth = { width: 15, padding: 0.5, maxValue: 24 };
  const rectYear = { width: 30, padding: 0.45, maxValue: 800 };
  const rectYearAverage = { width: 30, padding: 0.45, maxValue: 24 };

  if (viewType === 'week') {
    return rectWeek;
  } else if (viewType === 'month') {
    return rectMonth;
  }

  if (viewSubTypeForYear === 'average') {
    //for displaying the average per day (from the year graph)
    return rectYearAverage;
  }

  return rectYear;
};

const eventLegend = (data, display) => {
  // let total = {
  //   total: 0,
  //   lying: 0,
  //   sitting: 0,
  //   standing: 0,
  //   walking: 0,
  // };

  // if (data && data.length > 0) {
  //   total = (data || [])
  //     .map((d) => {
  //       return {
  //         lying: d.duration.lying,
  //         sitting: d.duration.sitting,
  //         standing: d.duration.standing,
  //         walking: d.duration.walking,
  //       };
  //     })
  //     .reduce(
  //       (a, b) => ({
  //         lying: a.lying + b.lying,
  //         sitting: a.sitting + b.sitting,
  //         standing: a.standing + b.standing,
  //         walking: a.walking + b.walking,
  //       }),
  //       total
  //     );
  // }

  // //convert seconds to hours
  // total.lying = total.lying / 3600;
  // total.sitting = total.sitting / 3600;
  // total.standing = total.standing / 3600;
  // total.walking = total.walking / 3600;

  const result = [
    {
      label: 'total',
      checked: display.total,
    },
    {
      label: 'lying',
      checked: display.lying,
      // show: +total.lying.toFixed(2) > 0,
    },
    {
      label: 'sitting',
      checked: display.sitting,
      // show: +total.sitting.toFixed(2) > 0,
    },
    {
      label: 'standing',
      checked: display.standing,
      // show: +total.standing.toFixed(2) > 0,
    },
    {
      label: 'walking',
      checked: display.walking,
      // show: +total.walking.toFixed(2) > 0,
    },
  ];
  return result;
};

const eventTotal = (data, display) => {
  let total = {
    lying: 0,
    sitting: 0,
    standing: 0,
    walking: 0,
  };

  if (data && data.length > 0) {
    total = (data || [])
      .map((d) => {
        return {
          lying: d.duration.lying,
          sitting: d.duration.sitting,
          standing: d.duration.standing,
          walking: d.duration.walking,
        };
      })
      .reduce(
        (a, b) => ({
          lying: a.lying + b.lying,
          sitting: a.sitting + b.sitting,
          standing: a.standing + b.standing,
          walking: a.walking + b.walking,
        }),
        total,
      );
  }
  //convert seconds to hours
  total.lying = total.lying / 3600;
  total.sitting = total.sitting / 3600;
  total.standing = total.standing / 3600;
  total.walking = total.walking / 3600;

  const totalTime = Object.values(total).reduce((a, b) => a + b, 0);

  const lying = total.lying ? (total.lying / totalTime) * 100 : 0;
  const sitting = total.sitting ? (total.sitting / totalTime) * 100 : 0;
  const standing = total.standing ? (total.standing / totalTime) * 100 : 0;
  const walking = total.walking ? (total.walking / totalTime) * 100 : 0;

  const result = [
    {
      label: 'lying',
      value: lying,
    },
    {
      label: 'sitting',
      value: sitting,
    },
    {
      label: 'standing',
      value: standing,
    },
    {
      label: 'walking',
      value: walking,
    },
  ];
  return result;
};

const eventAverage = (date, data, viewType, display) => {
  // const totalDays = 0;
  const totalDays = countDays(viewType, data);

  // if (viewType === "week") {
  //   const dateStart = moment(new Date(`${date}`))
  //     .subtract(1, "w")
  //     .add(1, "d")
  //     .startOf("day")
  //     .toDate();
  //   const dateEnd = moment(new Date(`${date}`))
  //     .endOf("day")
  //     .toDate();
  //   totalDays = countDays(viewType, data);
  // } else if (viewType === "month") {
  //   const dateStart = moment(new Date(`${date}`))
  //     .subtract(4, "w")
  //     .add(1, "d")
  //     .startOf("day")
  //     .toDate();
  //   const dateEnd = moment(new Date(`${date}`))
  //     .endOf("day")
  //     .toDate();

  //   totalDays = countDays(dateStart, dateEnd);
  // } else {
  //   const dateStart = moment(new Date(`${date}`))
  //     .subtract(1, "y")
  //     .add(1, "d")
  //     .startOf("month")
  //     .toDate();
  //   const dateEnd = moment(new Date(`${date}`))
  //     .startOf("month")
  //     .toDate();

  //   totalDays = countDays(dateStart, dateEnd);
  // }

  let totalAverage = {
    lying: 0,
    sitting: 0,
    standing: 0,
    walking: 0,
  };

  const eventData = (data || []).map((d) => {
    return {
      lying: d.duration.lying ? d.duration.lying : 0,
      sitting: d.duration.sitting ? d.duration.sitting : 0,
      standing: d.duration.standing ? d.duration.standing : 0,
      walking: d.duration.walking ? d.duration.walking : 0,
    };
  });

  if (eventData && eventData.length > 0) {
    // summary all
    totalAverage = eventData.reduce(
      (a, b) => ({
        lying: a.lying + b.lying,
        sitting: a.sitting + b.sitting,
        standing: a.standing + b.standing,
        walking: a.walking + b.walking,
      }),
      totalAverage,
    );
  }

  // find average in hours
  // const totalSeconds = totalDays * 3600;

  const lying = totalAverage.lying / totalDays;
  const sitting = totalAverage.sitting / totalDays;
  const standing = totalAverage.standing / totalDays;
  const walking = totalAverage.walking / totalDays;
  const result = [
    {
      label: 'lying',
      value: formattedNumber(lying),
      min: formattedNumber(
        Math.min.apply(
          null,
          eventData.map((item) => item.lying),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          eventData.map((item) => item.lying),
        ) / totalDays,
      ),
    },
    {
      label: 'sitting',
      value: formattedNumber(sitting),
      min: formattedNumber(
        Math.min.apply(
          null,
          eventData.map((item) => item.sitting),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          eventData.map((item) => item.sitting),
        ) / totalDays,
      ),
    },
    {
      label: 'standing',
      value: formattedNumber(standing),
      min: formattedNumber(
        Math.min.apply(
          null,
          eventData.map((item) => item.standing),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          eventData.map((item) => item.standing),
        ) / totalDays,
      ),
    },
    {
      label: 'walking',
      value: formattedNumber(walking),
      min: formattedNumber(
        Math.min.apply(
          null,
          eventData.map((item) => item.walking),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          eventData.map((item) => item.walking),
        ) / totalDays,
      ),
    },
  ];
  return result;
};

const formattedNumber = (num) => {
  let isFinite = Number.isFinite(num);
  if (isFinite) {
    let minutes = Math.round(num / 60);
    minutes = minutes % 60;
    let hours = Math.floor(num / 3600);
    let minutesFormat = `${minutes === 0 ? '00' : minutes < 10 ? '0' + minutes : minutes}`;
    let hoursFormat = `${hours === 0 ? '00' : hours < 10 ? '0' + hours : hours}`;
    return `${hoursFormat}:${minutesFormat}` === '00:00' ? 0 : `${hoursFormat}:${minutesFormat}`;
  } else {
    return '0';
  }
};

const getEventValueTotal = (isCalucateAverageForYear, duration, divider, noOfDate) => {
  const sum =
    (duration.lying / divider).toFixed(2) +
    (duration.sitting / divider).toFixed(2) +
    (duration.standing / divider).toFixed(2) +
    (duration.walking / divider).toFixed(2);

  if (isCalucateAverageForYear) {
    return (sum / noOfDate).toFixed(2);
  }
  return sum;
};

const getEventValue = (isCalucateAverageForYear, value, divider, noOfDate) => {
  if (isCalucateAverageForYear) {
    return (value / (noOfDate * divider)).toFixed(2);
  }
  return (value / divider).toFixed(2);
};

const eventGraphData = (date, data, viewType, viewSubTypeForYear, display, t) => {
  const templateEventDate = {
    total: { value: 0, hoverTxt: '', nameTxt: '' },
    lying: { value: 0, hoverTxt: '', nameTxt: '' },
    sitting: { value: 0, hoverTxt: '', nameTxt: '' },
    standing: { value: 0, hoverTxt: '', nameTxt: '' },
    walking: { value: 0, hoverTxt: '', nameTxt: '' },
  };
  let templateData = [];
  let isCalucateAverageForYear = false; //isCalucateAverage : calculate average or summary
  if (viewType === 'week') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateEventDate };
    });
  } else if (viewType === 'month') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(4, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateEventDate };
    });
  } else {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'y')
      .add(1, 'd')
      .startOf('month')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .startOf('month')
      .toDate();

    if (viewSubTypeForYear === 'average') {
      isCalucateAverageForYear = true;
    }

    const dateRange = yearDate(dateStart, dateEnd);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateEventDate };
    });
  }

  (data || []).forEach((d) => {
    if (d.duration) {
      const refDate = moment(new Date(`${d.createdDate}`));
      const found = templateData.find((t) => {
        if (viewType === 'year') {
          // return moment(t.refDate).isSame(refDate, 'month');
          return t.refDate === d.month;
        }
        return moment(t.refDate).isSame(refDate, 'day');
      });
      if (found) {
        found.total = display.total
          ? {
              value: +getEventValueTotal(isCalucateAverageForYear, d.duration, 3600, d.noOfDate),
              hoverTxt: getHoverText(getEventValueTotal(isCalucateAverageForYear, d.duration, 1, d.noOfDate)),
              nameTxt: `${t('total')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.lying = display.lying
          ? {
              value: +getEventValue(isCalucateAverageForYear, d.duration.lying, 3600, d.noOfDate),
              hoverTxt: getHoverText(getEventValue(isCalucateAverageForYear, d.duration.lying, 1, d.noOfDate)),
              nameTxt: `${t('lying')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.sitting = display.sitting
          ? {
              value: +getEventValue(isCalucateAverageForYear, d.duration.sitting, 3600, d.noOfDate),
              hoverTxt: getHoverText(getEventValue(isCalucateAverageForYear, d.duration.sitting, 1, d.noOfDate)),
              nameTxt: `${t('sitting')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.standing = display.standing
          ? {
              value: +getEventValue(isCalucateAverageForYear, d.duration.standing, 3600, d.noOfDate),
              hoverTxt: getHoverText(getEventValue(isCalucateAverageForYear, d.duration.standing, 1, d.noOfDate)),
              nameTxt: `${t('standing')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.walking = display.walking
          ? {
              value: +getEventValue(isCalucateAverageForYear, d.duration.walking, 3600, d.noOfDate),
              hoverTxt: getHoverText(getEventValue(isCalucateAverageForYear, d.duration.walking, 1, d.noOfDate)),
              nameTxt: `${t('walking')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
      }
    }
  });
  return templateData;
};

export default Event;
